import React, { Component } from 'react';

import NuxeoClient from '../../clients/NuxeoClient';
import EventUtils from '../../utils/EventUtils';

class NuxeoConnect extends Component {
  componentDidMount() {
    NuxeoClient
      .instance()
      .getUser()
      .then((user) => EventUtils.raiseEvent('connect', { user: user }, this.props));
  }
  
  render() {
    return (<div hidden></div>);
  }
}

export default NuxeoConnect;
